/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Concatène le prénom usuel et les prénoms complémentaires en les séparant
 * par une virgule (ex: "Jean, Pierre, Paul"), à l'image du format utilisé
 * par `formatNomClassement` ("NOM Prénom1, Prénom2, Prénom3").
 *
 * Si les prénoms complémentaires ne sont pas renseignés, seul le prénom
 * usuel est retourné (sans virgule superflue).
 */
const formatPrenoms = (
  prenom?: string | null,
  prenomsComplementaires?: string | null,
): string => {
  return [prenom, prenomsComplementaires]
    .map((partie) => partie?.trim())
    .filter((partie) => !!partie)
    .join(', ');
};

export default formatPrenoms;
